/**
 * Resolves platform-aware keyboard shortcut strings.
 *
 * Consumers write shortcuts using the MOD token (plus optionally SHIFT / ALT).
 * This composable replaces those tokens with the correct platform symbols at
 * render time so tooltips show the right key combination on every OS.
 *
 * Token map
 *   MOD   → ⌘  (macOS) | Ctrl  (other)
 *   SHIFT → ⇧  (macOS) | Shift (other)
 *   ALT   → ⌥  (macOS) | Alt   (other)
 *
 * Example input:  "MOD + SHIFT + B"
 * macOS output:   "⌘ + ⇧ + B"
 * Windows output: "Ctrl + Shift + B"
 */

const isMac = typeof navigator !== 'undefined' && navigator.platform.startsWith('Mac');

const TOKEN_MAP_MAC = { MOD: '⌘', SHIFT: '⇧', ALT: '⌥' };
const TOKEN_MAP_OTHER = { MOD: 'Ctrl', SHIFT: 'Shift', ALT: 'Alt' };
const TOKEN_RE = /\b(MOD|SHIFT|ALT)\b/gi;
const map = isMac ? TOKEN_MAP_MAC : TOKEN_MAP_OTHER;

// eslint-disable-next-line import/prefer-default-export
export function useModKey() {
  function resolveShortcut(shortcut) {
    if (!shortcut) return shortcut;
    return shortcut.replace(TOKEN_RE, (token) => map[token.toUpperCase()] ?? token);
  }

  return { isMac, resolveShortcut };
}
